import React from 'react';
// import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
// import AutoGraphRoundedIcon from '@mui/icons-material/AutoGraphRounded';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
// import BookmarksRoundedIcon from '@mui/icons-material/BookmarksRounded';
// import BookmarksOutlinedIcon from '@mui/icons-material/BookmarksOutlined';
import AddTaskRoundedIcon from '@mui/icons-material/AddTaskRounded';
// import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
export interface SubMenuItem {
  id: number;
  label: string;
  link: string;
}

export interface MenuItem {
  id: number;
  label: string;
  icon: React.ReactElement;
  activeIcon: React.ReactElement;
  link: string;
  hasSubmenu?: boolean;
  subMenu?: SubMenuItem[];
}

// export const MenuItems: MenuItem[] = [
//   {
//     id: 1,
//     label: 'Dashboard',
//     icon: <DashboardOutlinedIcon />,
//     activeIcon: <DashboardRoundedIcon color="inherit" />,
//     link: '/dashboard',
//     hasSubmenu: false,
//   },
//   {
//     id: 2,
//     label: 'Reports',
//     icon: <AutoGraphRoundedIcon />,
//     activeIcon: <AutoGraphRoundedIcon color="inherit" />,
//     link: '/reports',
//     hasSubmenu: true,
//     subMenu: [
//       {
//         id: 21,
//         label: 'Title Breakdown',
//         link: '/reports/title-breakdown',
//       },
//       {
//         id: 22,
//         label: 'Category Breakdown',
//         link: '/reports/category-breakdown',
//       },
//       {
//         id: 23,
//         label: 'Specialty Breakdown',
//         link: '/reports/specialty-breakdown',
//       },
//       {
//         id: 24,
//         label: 'State Breakdown',
//         link: '/reports/state-breakdown',
//       },
//       {
//         id: 25,
//         label: 'Zip Breakdown',
//         link: '/reports/zip-breakdown',
//       },
//       {
//         id: 26,
//         label: 'County Breakdown',
//         link: '/reports/county-breakdown',
//       },
//       {
//         id: 27,
//         label: 'State Map',
//         link: '/reports/state-map',
//       },
//     ],
//   },
//   {
//     id: 3,
//     label: 'Settings',
//     icon: <SettingsOutlinedIcon />,
//     activeIcon: <SettingsOutlinedIcon color="inherit" />,
//     link: '/settings',
//     hasSubmenu: true,
//     subMenu: [
//       {
//         id: 31,
//         label: 'Manage Users',
//         link: '/settings/manage-users',
//       },
//     ],
//   },
//   {
//     id: 4,
//     label: 'Saved Reports',
//     icon: <BookmarksOutlinedIcon />,
//     activeIcon: <BookmarksRoundedIcon color="inherit" />,
//     link: '/savedreports',
//     hasSubmenu: false,
//   },
//   {
//     id: 5,
//     label: 'Counts and Orders',
//     icon: <AddTaskRoundedIcon />,
//     activeIcon: <AddTaskRoundedIcon color="inherit" />,
//     link: '/manage-jobs',
//     hasSubmenu: false,
//   },
// ];
export const MenuItems: MenuItem[] = [
  {
    id: 1,
    label: 'Counts and Orders',
    icon: <AddTaskRoundedIcon />,
    activeIcon: <AddTaskRoundedIcon color="inherit" />,
    link: '/manage-jobs',
    hasSubmenu: false,
  },
  {
    id: 2,
    label: 'Settings',
    icon: <SettingsOutlinedIcon />,
    activeIcon: <SettingsOutlinedIcon color="inherit" />,
    link: '/settings',
    hasSubmenu: true,
    subMenu: [
      {
        id: 21,
        label: 'Manage Users',
        link: '/settings/manage-users',
      },
    ],
  }
 
];
